import Modal from './Modal'
import { ResponsiveImage } from '@bm-js/atlascloud-ui'
import { FileEntryFM } from '@bm-js/atlascloud-shared'
import { env } from '../utils/env'

type Props = {
  spotlight: FileEntryFM
  setSpotlight: (file: FileEntryFM | null) => void
}

const MediaSpotlight = ({ spotlight, setSpotlight }: Props) => {
  if (spotlight.type === 'image') {
    return (
      <Modal onClose={() => setSpotlight(null)}>
        <ResponsiveImage
          className='w-[80vw] max-w-[unset] max-h-[80vh] object-contain'
          file={spotlight}
        />
      </Modal>
    )
  }

  if (spotlight.type === 'video') {
    return (
      <Modal
        onClose={() => setSpotlight(null)}
        className='flex items-center justify-center'
      >
        <video
          src={`${env.s3FilesBase}/uploads/${spotlight.uuid}`}
          controls
          className='w-[80vw] max-w-[unset] max-h-[80vh] object-contain'
        />
      </Modal>
    )
  }

  return null
}

export default MediaSpotlight
